import withWatchlist from 'src/components/filmwebid/withWatchlist';
import SearchContentItem from 'src/components/search/SearchContentItem';
import type { WatchableContent } from 'src/lib/movieinfo/movieinfotypes';
import classNames from 'classnames';
import { isFilmwebSearchDocument, type ISearchResult } from "src/lib/types/search";
import styles from './ResultPosterRow.module.css';

//#region [Props]
type ResultPosterRowProps = {
    maxResults: number;
    searchResult: WatchableContent[] | ISearchResult[];

    className?: string;
    disabled?: boolean;
    clickTracker?: (id: string | number, title: string) => void;
    forceStreaming?: boolean; // use streaming link if available, even if isCinemaRelevant = true
    azureSearchEnabled?: boolean;
    azShowScore?: boolean;
    forceHardlinks?: boolean;
};
//#endregion

//#region [Component]
const WLSearchContentItem = withWatchlist(SearchContentItem, "content");

export default function ResultPosterRow({ searchResult, maxResults, className, disabled = false, clickTracker, forceStreaming = false, azureSearchEnabled = false, azShowScore = false, forceHardlinks = false }: ResultPosterRowProps) {
    return <div
        className={classNames(styles.SPosterRow, className, {
            [styles.includeMargins]: searchResult.length < maxResults,
            [styles.disabled]: disabled
        })}
        style={{ "--max-results": maxResults } as React.CSSProperties}
    >
        {searchResult.slice(0, maxResults).map(sr => (
            <WLSearchContentItem
                className={styles.SWLSearchContentItem}
                wlcClassName='RowItem'
                key={isSearchResult(sr) ? (isFilmwebSearchDocument(sr.document) ? (sr.document.edi ?? sr.document.streamingId) : sr.document.movieId) : (sr.streamingContentId ?? sr.movieId)}
                content={sr}
                clickTracker={clickTracker}
                forceStreaming={forceStreaming}
                azShowScore={azShowScore}
                forceHardlinks={forceHardlinks}
            />
        ))}
    </div>;
}
//#endregion
function isSearchResult(sr: WatchableContent | ISearchResult): sr is ISearchResult {
    return sr.__typename === "ISearchResult"
}
